export default __webpack_public_path__ + "static/media/background-truck-dark.834d814e.jpg";